export const indexRoomNames = (index: number, attachedString = "") => {
  switch (index) {
    case 0: {
      return `Erste${attachedString}`;
    }
    case 1: {
      return `Zweite${attachedString}`;
    }
    case 2: {
      return `Dritte${attachedString}`;
    }
    case 3: {
      return `Vierte${attachedString}`;
    }
    case 4: {
      return `Fünfte${attachedString}`;
    }
    case 5: {
      return `Sechste${attachedString}`;
    }
    case 6: {
      return `Siebte${attachedString}`;
    }
    case 7: {
      return `Achte${attachedString}`;
    }
    default: {
      return `Erste${attachedString}`;
    }
  }
};
